/**
 *
 * Asynchronously loads the component for ConfirmUserPage
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
